// A second "legend" row rendered below the chart, styled like Chart.js's
// native legend (colored dot, strikethrough when toggled off). Chart.js
// only supports one legend per chart, so extra filter dimensions get one
// of these.
const LegendToggleRow = ({ items, onToggle }) => (
  <div className="legend-toggle-row" role="group">
    {items.map((item) => (
      <button
        key={item.key}
        type="button"
        className={`legend-toggle-row__item${item.active ? "" : " legend-toggle-row__item--off"}`}
        onClick={() => onToggle(item.key)}
      >
        <span className="legend-toggle-row__dot" style={{ backgroundColor: item.color }} />
        {item.label}
      </button>
    ))}
  </div>
);

export default LegendToggleRow;
